/**
 * Purpose: Action completed confirmation modal
 *
 * Props:
 *    showModalSuccess: boolean type value to show or hide the modal
 *    title: object type value (Translation)
 *    message: object type value (Translation)
 *    fnAcceptButton: function linked to the modal's accept button
 *    size: 'sm' | 'lg' | 'xl'
 *    txtBtnAccept: alternative text for the accept button (Translation)
 *    txtBtnCancel: alternative text for the cancel button (Translation)
 *    fnCancelButton: function linked to the modal's cancel button
 */
import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { Modal, Row, Col, Button, Alert } from "react-bootstrap";
import TextLoading from "../TextLoading";

export default function ModalSuccess(props) {
  const [t] = useTranslation(["global"]);
  const txtBtnAccept = props.txtBtnAccept || t("global:buttons.accept");
  const txtBtnCancel = props.txtBtnCancel || t("global:buttons.cancel");
  const fnCancelButton = props.fnCancelButton || false;
  const acceptButtonVariant = props.acceptButtonVariant || "primary";
  const loading = props.loading || false;
  const textLoading = props.textLoading || txtBtnAccept;
  const id = props.id || "modalSuccess";
  const acceptButtonId = props.acceptButtonId || id + "AcceptBtn";

  return (
    <Modal
      id={id}
      show={props.showModalSuccess}
      size={props.size}
      aria-labelledby="contained-modal-title-md"
    >
      <Modal.Header className="modal-header">
        <Modal.Title className="modal-title text-center" id={id + "Title"}>
          {props.title}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="modal-body mbottom10">
        <Row>
          <Col md={12} style={{ textAlign: "justify" }} id={id + "Message"}>
            {props.message}
          </Col>
        </Row>
        {/**Errors */}
        {props.error && (
          <Row className="mt-3">
            <Col md={12}>
              <Alert variant="warning" id={id + "Alert"}>
                {props.error}
              </Alert>
            </Col>
          </Row>
        )}
      </Modal.Body>
      <Modal.Footer>
        <div>
          {fnCancelButton && (
            <Button
              id={id + "CancelBtn"}
              variant="outline-secondary"
              onClick={fnCancelButton}
              disabled={loading}
            >
              {txtBtnCancel}
            </Button>
          )}
          {props.fnAcceptButton && (
            <Button
              id={acceptButtonId}
              variant={acceptButtonVariant}
              onClick={props.fnAcceptButton}
              disabled={loading}
            >
              {loading ? (
                <TextLoading text={textLoading} variant="white" />
              ) : (
                txtBtnAccept
              )}
            </Button>
          )}
        </div>
      </Modal.Footer>
    </Modal>
  );
}

ModalSuccess.propTypes = {
  id: PropTypes.string,
  size: PropTypes.string,
  title: PropTypes.string,
  message: PropTypes.string,
  txtBtnAccept: PropTypes.string,
  fnAcceptButton: PropTypes.func,
  showModalSuccess: PropTypes.bool,
  txtBtnCancel: PropTypes.string,
  fnCancelButton: PropTypes.func,
  acceptButtonVariant: PropTypes.string,
  acceptButtonId: PropTypes.string,
  loading: PropTypes.bool,
  textLoading: PropTypes.string,
  error: PropTypes.string,
};
